import React, { useState, useEffect, useMemo } from 'react'; // Removed useRef since it's not used
import './App.css';
import Home from './Home';
import About from './About';
// import Projects from './Projects';
// import Blogs from './Blogs';
// import Contact from './Contact';

function App() {
  const [activeSection, setActiveSection] = useState('home');

  // Create refs for each section using useMemo
  const sectionRefs = useMemo(() => ({
    home: React.createRef(), 
    about: React.createRef(),
    projects: React.createRef(),
    blogs: React.createRef(),
    contact: React.createRef(),
  }), []);

  // Add this new function to handle smooth scrolling
  const handleNavClick = (e, sectionId) => {
    e.preventDefault();
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  useEffect(() => {
    const observerOptions = {
      root: null, // relative to document viewport
      rootMargin: '0px',
      threshold: 0.5, // Trigger when 50% of the section is visible
    };

    const observerCallback = (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setActiveSection(entry.target.id);
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    // Observe each section ref
    Object.values(sectionRefs).forEach(ref => {
      if (ref.current) {
        observer.observe(ref.current);
      }
    });

    // Cleanup observer on component unmount
    return () => {
      Object.values(sectionRefs).forEach(ref => {
        // Check if ref.current exists before trying to unobserve
        if (ref.current) {
          observer.unobserve(ref.current);
        }
      });
    };
  }, [sectionRefs]); // Dependency array remains the same, but sectionRefs is now stable

  return (
    <div>
      <nav className="navbar">
        <ul className="navbar-menu">
          <li className={`navbar-item ${activeSection === 'home' ? 'active' : ''}`}>
            <a href="#home" onClick={(e) => handleNavClick(e, 'home')}>Home</a>
          </li>
          <li className={`navbar-item ${activeSection === 'about' ? 'active' : ''}`}>
            <a href="#about" onClick={(e) => handleNavClick(e, 'about')}>About</a>
          </li>
        </ul>
      </nav>

      <section id="home" ref={sectionRefs.home}>
        <Home />
      </section>
      <section id="about" ref={sectionRefs.about}>
        <About />
      </section>
      {/* <section id="projects" ref={sectionRefs.projects}>
        <Projects />
      </section>
      <section id="blogs" ref={sectionRefs.blogs}>
        <Blogs />
      </section>
      <section id="contact" ref={sectionRefs.contact}>
        <Contact />
      </section> */}
    </div>
  );
}

export default App;